"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFaceTypeName = exports.stylesheetUrlTypeName = void 0;
const consts_1 = require("./consts");
exports.stylesheetUrlTypeName = 'stylesheetUrl';
exports.fontFaceTypeName = 'fontFace';
var index_1 = require("./consts/index");
Object.defineProperty(exports, "COLORS", { enumerable: true, get: function () { return index_1.COLORS; } });
Object.defineProperty(exports, "CONFIGURATION_TYPES", { enumerable: true, get: function () { return index_1.CONFIGURATION_TYPES; } });
